import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Heart, Check, Loader2, Film } from "lucide-react";
import { api, API } from "@/lib/api";

const voterId = () => {
  let v = localStorage.getItem("ws_voter_id");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("ws_voter_id", v); }
  return v;
};

export default function ShareLook() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [pick, setPick] = useState(null);
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.share(token, voterId()).then((r) => { setD(r); if (r.my_vote) { setPick(r.my_vote.snapshot_id); setName(r.my_vote.name); setComment(r.my_vote.comment); } })
      .catch((e) => setErr(e?.response?.data?.detail || "Link not available"));
  }, [token]);

  if (err) return <div className="min-h-screen flex items-center justify-center text-[#94A3B8]" data-testid="share-error">{err}</div>;
  if (!d) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#E6B04E]" /></div>;

  const submit = async () => {
    setBusy(true);
    try { const r = await api.shareVote(token, { snapshot_id: pick, voter_id: voterId(), name, comment }); setD({ ...d, my_vote: r.my_vote }); }
    finally { setBusy(false); }
  };
  const couple = [d.project?.bride, d.project?.groom].filter(Boolean).join(" & ");

  return (
    <div className="min-h-screen bg-[#0a0b10] text-[#F1F5F9] px-6 md:px-12 py-12 fade-up" data-testid="share-page">
      <div className="max-w-6xl mx-auto space-y-8">
        <div className="space-y-2">
          <div className="flex items-center gap-2 metric-label"><Film size={13} className="text-[#E6B04E]" />{couple || d.project?.name}{d.project?.venue ? ` · ${d.project.venue}` : ""}</div>
          <h1 className="font-head text-4xl sm:text-5xl font-extrabold tracking-tight" data-testid="share-title">{d.title}</h1>
          {d.message && <p className="text-[#94A3B8] max-w-2xl" data-testid="share-message">{d.message}</p>}
          <p className="text-[#64748B] text-sm">Tap the look you love most, then send your vote.</p>
        </div>
        <div className={`grid gap-5 ${d.looks.length > 2 ? "md:grid-cols-2" : "md:grid-cols-2"}`}>
          {d.looks.map((l) => (
            <button key={l.id} onClick={() => setPick(l.id)} data-testid={`share-look-${l.id}`}
              className={`text-left rounded-2xl p-3 border-2 transition-[border-color,transform] hover:-translate-y-0.5 bg-[#12141c] ${pick === l.id ? "border-[#E6B04E]" : "border-[#252A3B]"}`}>
              <div className={`grid gap-2 ${d.frames > 1 ? "grid-cols-2" : ""}`}>
                {Array.from({ length: d.frames }, (_, i) => (
                  <img key={i} src={`${API}/share/${token}/preview/${l.id}/${i}`} alt={l.name} loading="lazy"
                    className={`w-full aspect-video object-cover rounded-lg bg-black ${d.frames === 3 && i === 0 ? "col-span-2" : ""}`} />
                ))}
              </div>
              <div className="flex items-center justify-between mt-3 px-1">
                <span className="font-head font-bold text-lg">{l.name}</span>
                {pick === l.id ? <span className="chip bg-[#E6B04E] text-[#1a1405]"><Heart size={11} />Your pick</span> : <span className="metric-label">tap to choose</span>}
              </div>
            </button>
          ))}
        </div>
        <div className="studio-card p-5 space-y-3 max-w-2xl">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" className="studio-input text-sm" data-testid="share-name" />
          <textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={3} placeholder="Anything you'd like changed? (optional)" className="studio-input text-sm w-full" data-testid="share-comment" />
          <button className="btn btn-gold" disabled={!pick || busy} onClick={submit} data-testid="share-submit">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <Heart size={15} />}{d.my_vote ? "Update my vote" : "Send my vote"}
          </button>
          {d.my_vote && <p className="text-sm text-[#34d399] flex items-center gap-1.5" data-testid="share-voted"><Check size={14} />Thanks{d.my_vote.name ? `, ${d.my_vote.name}` : ""}! Your vote for “{d.looks.find((l) => l.id === d.my_vote.snapshot_id)?.name}” was sent.</p>}
        </div>
      </div>
    </div>
  );
}
